var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-centered always-on-top dark-stars",attrs:{"id":"LoadingSpinner"}},[_c('div',[_c('Logo'),_c('div',{staticClass:"loading-message loading-dots"},[_vm._v("Loading")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }